import React from 'react';
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from 'reactstrap';
import StorageService from '../services/StorageService';
import axios from 'axios';
import {
  MdDone,
  MdClear,
  MdCreate,
  MdCancel,
  MdCameraAlt,
} from 'react-icons/md';
import logo200Image from '../assets/img/logo/20200723_UnitySuiteSqLogo512.webp';
import bg from '../assets/img/logo/bg-5.jpg';

const images = [{ name: logo200Image }, { name: logo200Image }, { name: bg }];

class PersonForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      personName: '',
      personID: '',
      searchKey: '',
      formdata: [],
      editFormData: [],
      newDataFieldList: [],
      photos: [],
      imagePreviewUrl: [],
      //imagePreviewUrl: [{ name: '' }],
    };
  }

  handleChange(i, event) {
    const { name, value } = event.target;
    let formdata = [...this.state.formdata];
    formdata[i] = { ...formdata[i], [name]: value };
    this.setState({ formdata });
    //console.log(this.state.formdata);
  }

  handleEditChange(i, event) {
    const { name, value } = event.target;
    let editFormData = [...this.state.editFormData];
    editFormData[i].value = value;
    this.setState({ editFormData });
  }

  changeHandler = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  handleImageChange = event => {
    let reader = new FileReader();
    if (Object.keys(event.target.files).length == 0) {
      // Object is empty
    } else {
      let file = event.target.files[0];
      console.log(event.target.files);

      reader.onloadend = () => {
        this.setState({
          imagePreviewUrl: [
            ...this.state.imagePreviewUrl,
            { name: reader.result },
          ],
        });
      };

      reader.readAsDataURL(file);
    }
  };

  handleSubmit = event => {
    event.preventDefault();
    const user = StorageService.getSession('user_info');
    const url = process.env.REACT_APP_API_URL;
    const org = StorageService.getSession('selected_org');
    let personData = {};

    for (let i = 0; i < this.state.formdata.length; i++) {
      for (var prop in this.state.formdata[i]) {
        personData[prop] = this.state.formdata[i][prop];
      }
    }

    if (!this.props.data.isEdit) {
      const data = {
        session_key: user.session_key,
        CompanyID: org.CompanyID,
        PersonType: this.props.data.typeName,
        PersonData: personData,
        Photos: this.state.imagePreviewUrl,
      };
      axios
        .post(url + ':3000/v1/person/create', data)
        .then(response => {
          const result = response.data;
          if (result.error == true) {
            this.props.closeModal(<MdClear />, result.message, 'error', false);
            return;
          }
          this.props.closeModal(
            <MdDone />,
            this.props.data.typeName + ' added successfully.',
            'success',
            false,
          );
        })
        .catch(error => {
          alert(error);
        });
    } else {
      let editPersonData = {};

      for (let i of this.state.editFormData) {
        editPersonData[i.name] = i.value;
      }

      const data = {
        session_key: user.session_key,
        CompanyID: org.CompanyID,
        PersonType: this.props.data.typeName,
        PersonID: this.props.data.personId,
        PersonData: editPersonData,
        Photos: this.state.imagePreviewUrl,
      };
      axios
        .post(url + ':3000/v1/person/update', data)
        .then(response => {
          const result = response.data;
          if (result.error == true) {
            this.props.closeModal(<MdClear />, result.message, 'error', false);
            return;
          }
          this.props.closeModal(
            <MdDone />,
            this.props.data.typeName + ' updated successfully.',
            'success',
            false,
          );
        })
        .catch(error => {
          alert(error);
        });
    }
  };

  remove = i => {
    var array = [...this.state.imagePreviewUrl]; // make a separate copy of the array
    array.splice(i, 1);
    this.setState({ imagePreviewUrl: array });
  };

  componentDidMount() {
    if (this.props.data.isEdit) {
      let id = this.props.data.personId;
      const person = this.props.data.personList.find(e => e.PersonID === id);
      let count = 0;
      this.setState({ imagePreviewUrl: person.ImagePath });
      let editFormData = [...this.state.editFormData];
      for (let k of this.props.data.dataFieldList) {
        for (var prop in person.PersonData) {
          k.value = '';
          if (k.FieldName === prop) {
            k.value = person.PersonData[prop];
            break;
          }
        }

        editFormData = [...editFormData, { name: k.FieldName, value: k.value }];

        // editFormData[count] = {
        //   ...editFormData[count],
        //   [k.FieldName]: k.value,
        //   {name: k.FieldName, value: k.value}
        // };

        this.setState({ editFormData });
        count++;
      }
      this.setState({
        newDataFieldList: this.props.data.dataFieldList,
      });
    }
  }

  render() {
    return (
      <Form onSubmit={this.handleSubmit} className="AuthForm">
        <ModalHeader toggle={this.props.onToggleModal()}>
          Person Information
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={12}>
              <div>
                <Input
                  type="file"
                  name="file"
                  id="file"
                  className="ps-input-file"
                  onChange={this.handleImageChange}
                />
                <Label for="file">
                  <MdCameraAlt /> Upload Photo
                </Label>
              </div>
              <div
                className={`ps-photo ${
                  this.state.imagePreviewUrl.length < 1 ? ' empty' : ''
                }`}
              >
                {this.state.imagePreviewUrl.length < 1 && <p>No photo</p>}
                {this.state.imagePreviewUrl.length > 0 &&
                  this.state.imagePreviewUrl.map((item, index) => {
                    return (
                      item.name !== '' && (
                        <div className="image" key={index}>
                          <MdCancel
                            className="remove"
                            onClick={() => this.remove(index)}
                          />
                          <img src={item.name} alt="logo" />
                        </div>
                      )
                    );
                  })}
              </div>
              {this.props.data.isEdit &&
                this.state.editFormData.length > 0 &&
                this.state.editFormData.map((item, index) => {
                  return (
                    <FormGroup key={index}>
                      <Label>{item.name}</Label>
                      <Input
                        type="text"
                        name={item.name}
                        value={item.value}
                        onChange={this.handleEditChange.bind(this, index)}
                        required
                      />
                    </FormGroup>
                  );
                })}

              {!this.props.data.isEdit &&
                this.props.data.dataFieldList.length > 0 &&
                this.props.data.dataFieldList.map((item, index) => {
                  return (
                    <FormGroup key={index}>
                      <Label>{item.FieldName}</Label>
                      <Input
                        type="text"
                        name={item.FieldName}
                        onChange={this.handleChange.bind(this, index)}
                        required
                      />
                    </FormGroup>
                  );
                })}

              {/* <FormGroup>
                <Label for="personName">Person Name</Label>
                <Input
                  type="text"
                  name="personName"
                  value={this.state.personName}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup>

              <FormGroup>
                <Label for="personID">Person ID</Label>
                <Input
                  type="text"
                  name="personID"
                  value={this.state.personID}
                  onChange={this.changeHandler}
                  required
                />
              </FormGroup> */}
              {/* <FormGroup>
                <Label for="searchKey">Search Key</Label>
                <Input
                  type="select"
                  name="searchKey"
                  value={this.state.searchKey}
                  onChange={this.changeHandler}
                  disabled={this.props.data.isEdit ? true : false}
                >
                  <option value=""></option>
                  {this.props.data.dataFieldList.length > 0 &&
                    this.props.data.dataFieldList.map((item, index) => {
                      return (
                        <option key={index} value={item.FieldName}>
                          {item.FieldName}
                        </option>
                      );
                    })}
                </Input>
              </FormGroup> */}
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button
            className="theme-button theme-button-secondary"
            onClick={this.props.onToggleModal()}
          >
            Close
          </Button>
          <Button className="theme-button theme-button-primary" type="submit">
            {this.props.data.isEdit ? 'Save' : 'Add Person'}
          </Button>{' '}
        </ModalFooter>
      </Form>
    );
  }
}

export default PersonForm;
